
















































































































































import Vue from "vue";
import { mapState } from "vuex";
import Footer from "../components/master/Footer.vue";
import PasswordInput from "../components/common/passwordInput.vue";
import ImageInput from "../components/common/imageinput.vue";
import UserAvatar from "../components/common/user-avatar.vue";
import AbpBase from "../lib/abpbase";
import util from "../lib/util";
import { VueTelInput } from "vue-tel-input";
import PrivacyModal from "../components/legal-docs/privacy-modal.vue";
import TermsModal from "../components/legal-docs/terms-modal.vue";

let _: any = require("lodash");
const prefixCls = "wizard";

export default AbpBase.extend({
  components: {
    Footer,
    PasswordInput,
    ImageInput,
    UserAvatar,
    VueTelInput,
    PrivacyModal,
    TermsModal,
  },
  data() {
    return {
      showPrivacy: false,
      showTerms: false,
      registrationModel: {
        id: 0,
        name: "",
        emailAddress: "",
        newPassword: "",
        newPasswordConfirm: "",
        phoneNumber: "",
        securityStamp: "",
        avatar: null,
        accountName: "",
        logoImage: null,
      },
      bindPhoneProps: {
        mode: "international",
        defaultCountry: "US",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Mobile Phone (for two-factor authentication)",
        //required: true,
        enabledCountryCode: false,
        enabledFlags: true,
        preferredCountries: ["US"],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
          disabledDialCode: false,
        },
        inputOptions: {
          showDialCode: false,
        },
      },
      has_eight_characters: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      saving: false,
      saved: false,
      currentStep: "name",
      currentStepIndex: 0,
      confirmation: null,
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in your full name",
            trigger: "blur",
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: "Please fill in your mobile phone number",
            trigger: "change",
          },
        ],
        newPassword: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("Please fill in your new password"));
              } else {
                if ((this as any).checkPassword(value)) {
                  if ((this as any).registrationModel.newPasswordConfirm !== "") {
                    (this.$refs.passwordForm as any).validateField("newPasswordConfirm");
                  }
                } else {
                  callback(new Error("Not a valid password."));
                }

                callback();
              }
            },
            trigger: "blur",
          },
        ],
        newPasswordConfirm: [
          {
            validator: (rule, value, callback) => {
              if (value !== (this as any).registrationModel.newPassword) {
                callback(new Error("Passwords do not match!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("session", ["user"]),
    dotsClasses() {
      return [`${prefixCls}-dots`, `${prefixCls}-dots-inside`];
    },
  },
  methods: {
    goToHomePage() {
      location.replace(window.location.origin + abp.appPath);
    },
    gotoLoginPage() {
      this.$store.commit("app/logout", this);
      util.abp.auth.clearToken();
      location.reload();
    },
    checkPassword(input) {
      let password = input || this.registrationModel.newPassword;
      this.has_eight_characters = password && password.length > 7;
      this.has_number = /\d/.test(password);
      this.has_lowercase = /[a-z]/.test(password);
      this.has_uppercase = /[A-Z]/.test(password);
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(password);

      return this.has_eight_characters && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special;
    },
    handlerWizardStep(offset) {
      let steps = ["name", "password", "phoneNumber", "loading", "confirmation"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.currentStep) + offset;
      this.currentStepIndex = nextStepIndex;
      this.currentStep = steps[nextStepIndex];
    },
    nextStep() {
      if (this.currentStep !== "confirmation") {
        (this.$refs[this.currentStep + "Form"] as any).validate(async (valid: boolean) => {
          if (valid) {
            this.handlerWizardStep(1);
          }
        });
      }
    },
    async updateProfile() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this;
      (this.$refs.phoneNumberForm as any).validate(async (valid: boolean) => {
        if (valid) {
          context.handlerWizardStep(1);
          let requestData = {
            //billingAccountName: this.registrationModel.accountName,
            name: this.registrationModel.name,
            emailAddress: (this as any).user.emailAddress,
            changePassword: true,
            currentPassword: window.abp.custom.passwordResetCode,
            newPassword: this.registrationModel.newPassword,
            phoneNumber: this.registrationModel.phoneNumber,
            changeAvatarImage: false,
            avatarImage: "",
            logoImage: this.registrationModel.logoImage ? this.registrationModel.logoImage.imageURL : null,
          };

          context.$store
            .dispatch("account/updateProfile", requestData)
            .then((response) => {
              if (response.success === true) {
                this.confirmation = response;
                context.handlerWizardStep(1);
              } else {
                this.$Modal.error({
                  title: "Oops!",
                  render: (h) => {
                    return h("p", [h("span", {}, "failed to create your account")]);
                  },
                });

                context.handlerWizardStep(-3);
              }
              //location.replace(window.location.origin + abp.appPath);
            })
            .finally(() => {
              target.disabled = false;
            });
        } else {
          target.disabled = false;
        }
      });
    },
    validatePhoneNumber() {
      let field = this.$refs.PhoneNumberField as any;
      field.validate("");
    },
  },
});
